import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export const TEST_ID_SEASON_CARD_MISSING_INFORMATION =
  "season-card-missing-information";
export const TEST_ID_TITLE = "season-card-missing-information-title";
export const TEST_ID_BODY_TEXT =
  "season-card-missing-information-title-body-text";
export const TEST_ID_EMAIL = "season-card-missing-information-title-email";
export const TEST_ID_PHONE = "season-card-missing-information-title-phone";

interface SeasonCardMissingInformationProps {
  id: string;
}

const SeasonCardMissingInformation: React.FC<
  SeasonCardMissingInformationProps
> = ({ id }) => {
  const { formatMessage } = useIntl();

  const email = formatMessage({
    id: "seasonCardPage.missingInformation.email",
  });
  const phone = formatMessage({
    id: "seasonCardPage.missingInformation.phone",
  });
  return (
    <div
      className="ma3 tc"
      data-testid={TEST_ID_SEASON_CARD_MISSING_INFORMATION}
    >
      <h1 data-testid={TEST_ID_TITLE}>
        <FormattedMessage id="seasonCardPage.missingInformation.title" />
      </h1>
      <p className="f4" data-testid={TEST_ID_BODY_TEXT}>
        <FormattedMessage
          id="seasonCardPage.missingInformation.body"
          values={{ id }}
        />
      </p>
      <ul className="list f4 mv2">
        <li className="mb2">
          <a
            className="pink no-underline"
            href={`mailto:${email}`}
            data-testid={TEST_ID_EMAIL}
          >
            {email}
          </a>
        </li>
        <li>
          <a
            className="pink no-underline"
            href={`tel:${phone}`}
            data-testid={TEST_ID_PHONE}
          >
            {phone}
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SeasonCardMissingInformation;
